export const envYear = 2021;
export const startDate = "2021-10-30"
export const endDate = "2021-11-08"

export const apiEnv = () => {
    switch (location.host) {
      //  == DEVELOPMENT ==
      case "localhost:8080":
      case "localhost:8081":
      case "0.0.0.0:8080":
      case "0.0.0.0:8081":
      case "127.0.0.1:8080":
      case "127.0.0.1:8081":
        var apiPath = "http://localhost:8000/api";
        break;
      //  == STAGING ==
      case `stg-${envYear}-tiff.kray.jp`:
        var apiPath = `http://stg-api-${envYear}-tiff.kray.jp/api`;
        break;
      //  == PRODUCTION ==
      default:
        var apiPath = `https://api-${envYear}.tiff-jp.net/api`;
        break;
    }
    return apiPath;
}
export const ticketEnv = () => {
    switch (location.host) {
      //  == DEVELOPMENT ==
      case "localhost:8080":
      case "localhost:8081":
      case "0.0.0.0:8080":
      case "0.0.0.0:8081":
      case "127.0.0.1:8080":
      case "127.0.0.1:8081":
        var ticketPath = "https://db5rm9het8lps.cloudfront.net";
        break;
      //  == STAGING ==
      case `stg-${envYear}-tiff.kray.jp`:
        var ticketPath = "https://db5rm9het8lps.cloudfront.net";
        break;
      //  == PRODUCTION ==
      default:
        var ticketPath = "https://entry.tiff-ticket.net";
        break;
    }
    return ticketPath;
}



// WEBPACK FOOTER //
// ./src/env.js